/**
 * Intervalo de atualização automática das telas que exibem status.
 *
 * O KAVI é multiusuário por natureza: a UBS registra, a Regulação decide, e as
 * duas pontas costumam estar com a tela aberta ao mesmo tempo. Sem atualização
 * automática, a UBS só descobre uma devolução ao apertar F5 — e a Regulação
 * trabalha sobre uma fila que pode já ter mudado.
 *
 * Dez segundos é o compromisso: perto o suficiente de tempo real para o
 * operador confiar no que vê, e longe o suficiente para não pesar no servidor.
 * O TanStack Query pausa o polling quando a aba perde o foco
 * (`refetchIntervalInBackground` é falso por padrão), então uma aba esquecida
 * aberta a tarde inteira não gera tráfego.
 */
export const INTERVALO_ATUALIZACAO_MS = 10_000;
